import Reac from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
const TabComponent = ({ tabContent }) => {
  return (
    <>
      <Tabs>
        <TabList>
          {tabContent.map((t) => (
            <Tab key={t.id}>{t.title}</Tab>
          ))}
        </TabList>

        {tabContent.map((t) => (
          <TabPanel key={t.id}>{t.content}</TabPanel>
        ))}
      </Tabs>
    </>
  );
};

export default TabComponent;
